export default __webpack_public_path__ + "static/tim-2763ffe830d54c5d00b11143421847de.png";